import React from "react";
import HeadingWithLine from "../../../../../components/HeadingWithLine/HeadingWithLine";
import { getPricingName, getPricingDataById } from "../../../../../../components/helper/helper";

function FlatRate({ appData }) {
  return (
    <>
      <ul>
        <li>
          <div>
            <p>Pricing model</p>
            <p>{getPricingName(appData.qualifiedtype)}</p>
          </div>
        </li>
      </ul>

      {/* Surcharge Rates */}
      <div>
        {/* <HeadingWithLine text="Pin-Based Debit" /> */}
        <ul>
          <li>
            <div>
              <p>Flat Rate</p>
              <p>{getPricingDataById(appData, 2).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Transaction Fee</p>
              <p>$ {getPricingDataById(appData, 2).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Amex */}
      <div>
        <HeadingWithLine text="Amex" />
        <ul>
          <li>
            <div>
              <p>Flat Rate</p>
              <p>{getPricingDataById(appData, 35).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Transaction Fee</p>
              <p>$ {getPricingDataById(appData, 35).dollars}</p>
            </div>
          </li>
        </ul>
      </div>

      {/* Pin Based Debit */}
      <div>
        <HeadingWithLine text={`Pin-Based Debit${appData?.billing?.network_fee === "no" ? " (Disabled)" : ""}`} />
        <ul>
          <li>
            <div>
              <p>Debit Rate</p>
              <p>{getPricingDataById(appData, 5).percent}%</p>
            </div>
          </li>
          <li>
            <div>
              <p>Per Transaction</p>
              <p>$ {getPricingDataById(appData, 5).dollars}</p>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
}

export default FlatRate;
